import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.8);
`

const Message = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 400px;
  text-align: center;
  opacity: 0.7;
  font-size: 2em;
  font-weight: 600;
  line-height: 1.4;
`

class Dropzone extends React.Component {
  state = {
    isHovering: false,
  }

  componentDidMount() {
    document.addEventListener('dragenter', this.handleDragenter)
    document.addEventListener('dragover', this.handleDragover)
    document.addEventListener('dragleave', this.handleDragleave)
    document.addEventListener('drop', this.handleDrop)
  }

  componentWillUnmount() {
    document.removeEventListener('dragenter', this.handleDragenter)
    document.removeEventListener('dragover', this.handleDragenter)
    document.removeEventListener('dragleave', this.handleDragleave)
    document.removeEventListener('drop', this.handleDrop)
  }

  dragTarget = null

  swallowEvent = e => {
    e.preventDefault()
    e.stopPropagation()
  }

  handleDragenter = e => {
    this.swallowEvent(e)
    this.setState({ isHovering: true })
    this.dragTarget = e.target
  }

  handleDragover = this.swallowEvent

  handleDragleave = e => {
    this.swallowEvent(e)
    if (e.target !== this.dragTarget) return
    this.setState({ isHovering: false })
  }

  handleDrop = e => {
    this.swallowEvent(e)
    this.setState({ isHovering: false })
    const files = e.dataTransfer.files
    if (!files) return
    this.props.onDropFile(files[0])
  }

  render() {
    if (!this.state.isHovering) return <noscript />
    return (
      <Overlay>
        <Message>Drop file to preview and upload</Message>
      </Overlay>
    )
  }
}

Dropzone.propTypes = {
  onDropFile: PropTypes.func,
}

export default Dropzone



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/help/components/Dropzone.js